<!-- 展示驳回原因弹窗 -->
<template>
    <el-dialog title="驳回原因" :visible.sync="isShow" top="100px" width="30%" custom-class="custom-dialog-class">
        <div class="dialog-container">
            {{`驳回原因：${reasonTxt || ''}`}}
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="toggleReasonDialog(false)">确 定</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
export default {
    name: 'ShowReasonDialog',
    props: {
        isOpen: {
            type: Boolean,
            default: () => false,
        },
        toggleReasonDialog: {
            type: Function,
            default: () => {}
        },
        reasonTxt: {
            type: String,
            default: () => ''
        }
    },
    computed: {
        isShow: {
            get() {
                return this.isOpen;
            },
            set(val) {
                this.toggleReasonDialog(val);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    width: 400px;
    margin: 0 auto;
}
</style>